import { uploadImages } from '@/service-worker/image/upload-images'
import { vanillaApiClient } from '@/trpc/vanilla'

interface FallbackSaveImagesArgs {
  momentId: string
  images: File[]
  encryptKey: string
}

export const fallbackSaveImages = async ({
  momentId,
  images,
  encryptKey,
}: FallbackSaveImagesArgs) => {
  if (images.length === 0) return

  const [imagePaths] = await Promise.all([
    Promise.all(
      images.map((image) =>
        uploadImages({
          image,
          encryptKey,
          fileName: image.name,
        }).catch((error) => {
          console.error(error)
          return null
        }),
      ),
    ).then((paths) => {
      return paths.filter(
        (
          path,
        ): path is {
          original: string
          type: string
          thumbnail: string
        } => path !== null,
      )
    }),
  ])

  if (imagePaths.length > 0) {
    await vanillaApiClient.momentImages.createMany.mutate({
      momentId,
      images: imagePaths,
    })
  }
}
